'use client'

import type { HeaderControlProps } from '@maestro/commerce-blocks/components/header-controls/header-controls.types'

import classNames from 'classnames'
import React from 'react'

import HeaderControlCounter from '@maestro/commerce-blocks/components/header-controls/header-control-counter'
import { Icon } from '@pearlconvert/ui/components/icon'
import { Link } from '@pearlconvert/ui/components/link'

import '@maestro/commerce-blocks/components/header-controls/styles/header-controls.scss'

const HeaderControl = (props: HeaderControlProps) => {
  const {
    icon,
    title = '',
    ariaLabel = '',
    url = '',
    onClick,
    count,
    isHighlighted = false,
    customClassName,
  } = props
  const Component: React.ElementType = url ? Link : 'button'

  const componentProps = {
    className: classNames('header-control', customClassName, {
      'header-control--highlight': isHighlighted,
    }),
    'aria-label': ariaLabel || title, // aria-label=title is a fallback for mobile where title is not displayed
    title: title ? undefined : ariaLabel,
    ...(url ? { href: url } : { type: 'button' as HTMLButtonElement['type'] }),
    ...(onClick && { onClick }),
  }

  return (
    <Component {...componentProps}>
      <div className="header-control__icons">
        {typeof icon === 'string' ? (
          <Icon className="header-control__icon" icon={icon} size="large" />
        ) : (
          icon
        )}
        {count !== undefined && <HeaderControlCounter count={count} />}
      </div>
      {title && <span className="header-control__title">{title}</span>}
    </Component>
  )
}

export default HeaderControl
